import { useI18n } from 'vue-i18n';

export const languages = [
    {id: 'es', title: 'Español'},
    {id: 'en', title: 'English'},
    {id: 'fr', title: 'Français'},
    {id: 'pt', title: 'Português'},
    {id: 'it', title: 'Italiano'},
    {id: 'de', title: 'Deutsch'},
]
  